import React from "react";

const DeliveryPage = () => {
    return <div>Delivery</div>
}

export default DeliveryPage;